import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faPlus } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateServerRefreshTable } from "../../../redux/servers/serverSlice";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function ServersHeader() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleReloadPage = () => {
    dispatch(updateServerRefreshTable(true));
    setTimeout(() => {
      dispatch(updateServerRefreshTable(false));
    }, 1000);
  };

  const handleNavigateCreateServer = () => {
    navigate({ pathname: "/edge-management/servers/create" });
  };

  const actionButtonStyle = {
    width: 170,
    height: 40,
  };

  return (
    <div>
      <div className="generalStyles__pageHeader">
        {hasPermission(Permission.ServersView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              className="buttonStyle__1"
              icon={<FontAwesomeIcon icon={faPlus} className="generalStyles__mrFix" />}
              style={actionButtonStyle}
              onClick={handleNavigateCreateServer}
            >
              {t("edgeManagement.servers.createNewServer")}
            </Button>
          </div>
        )}
        {hasPermission(Permission.ServersView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              className="buttonStyle__8"
              icon={<FontAwesomeIcon icon={faArrowsRotate} className="generalStyles__mrFix" />}
              style={actionButtonStyle}
              onClick={() => {
                handleReloadPage();
              }}
            >
              {t("edgeManagement.servers.refreshTable")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ServersHeader;
